export default "__VITE_ASSET__FK5HXol9__"